var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExpandCollapse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_170_2022",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12ZM20 12C20 16.4183 16.4183 20 12 20C7.58172 20 4 16.4183 4 12C4 7.58172 7.58172 4 12 4C16.4183 4 20 7.58172 20 12ZM11.2929 14.9926C11.4882 15.1879 11.7441 15.2855 12 15.2855C12.058 15.2855 12.1159 15.2805 12.1731 15.2705C12.3687 15.2363 12.5561 15.1437 12.7071 14.9926L16.2427 11.4571C16.6332 11.0666 16.6332 10.4334 16.2427 10.0429C15.8522 9.65237 15.219 9.65237 14.8285 10.0429L12 12.8713L9.17158 10.0429C8.78106 9.65237 8.14789 9.65237 7.75737 10.0429C7.36685 10.4334 7.36685 11.0666 7.75737 11.4571L11.2929 14.9926Z",
    fill: "black"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_170_2022)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#B6B6BF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpandCollapse);
export default __webpack_public_path__ + "static/media/expand-collapse.5ad573bcba9fe24641590b9d9f355bfa.svg";
export { ForwardRef as ReactComponent };